// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cloud-drive-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
  padding: 10px 0;
}
.import-dialog-folder-button {
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 15px;
  margin-right: 15px;
}
.import-dialog-folder-icon {
  font-size: 20px;
}
.backup-dialog-title {
  width: 120px;
  height: 20px;
  font-size: 18px;
  opacity: 1;
  width: 100%;
  text-align: center;
  position: absolute;
  top: 22px;
  font-weight: 500;
}
.cloud-drive-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 15px;
  padding-right: 10px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.cloud-drive-label {
  font-size: 15px;
  line-height: 1.5;
  font-weight: 500;
  width: calc(100% - 50px);
  text-overflow: ellipsis;
  overflow: hidden;
  margin-right: 10px;
}
.import-dialog-more-file {
  transform: rotate(-90deg);
  font-size: 13px;
  width: 20px;
  position: relative;
  bottom: 4px;
}
.import-dialog-option {
  width: calc(100% - 10px);
  padding-left: 10px;
  overflow-y: scroll;
  position: absolute;
  top: 50px;
  bottom: 50px;
}
.import-dialog-back-button {
  position: absolute;
  bottom: 20px;
  right: 20px;
  font-size: 16px;
  cursor: pointer;
}
.cloud-drive-label:hover {
  color: #f16464;
}
`, "",{"version":3,"sources":["webpack://./src/components/dialogs/importDialog/importDialog.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;EACX,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,yBAAyB;EACzB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,eAAe;AACjB;AACA;EACE,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,wBAAwB;EACxB,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,yBAAyB;EACzB,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,SAAS;EACT,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,eAAe;AACjB;AACA;EACE,cAAc;AAChB","sourcesContent":[".cloud-drive-list {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  width: 100%;\n  padding: 10px 0;\n}\n.import-dialog-folder-button {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  font-size: 15px;\n  margin-right: 15px;\n}\n.import-dialog-folder-icon {\n  font-size: 20px;\n}\n.backup-dialog-title {\n  width: 120px;\n  height: 20px;\n  font-size: 18px;\n  opacity: 1;\n  width: 100%;\n  text-align: center;\n  position: absolute;\n  top: 22px;\n  font-weight: 500;\n}\n.cloud-drive-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 12px 15px;\n  padding-right: 10px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.cloud-drive-label {\n  font-size: 15px;\n  line-height: 1.5;\n  font-weight: 500;\n  width: calc(100% - 50px);\n  text-overflow: ellipsis;\n  overflow: hidden;\n  margin-right: 10px;\n}\n.import-dialog-more-file {\n  transform: rotate(-90deg);\n  font-size: 13px;\n  width: 20px;\n  position: relative;\n  bottom: 4px;\n}\n.import-dialog-option {\n  width: calc(100% - 10px);\n  padding-left: 10px;\n  overflow-y: scroll;\n  position: absolute;\n  top: 50px;\n  bottom: 50px;\n}\n.import-dialog-back-button {\n  position: absolute;\n  bottom: 20px;\n  right: 20px;\n  font-size: 16px;\n  cursor: pointer;\n}\n.cloud-drive-label:hover {\n  color: #f16464;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
